import { type ComponentProps, type FC, memo } from "react";
import { ButtonKind, ButtonShape, ButtonSize, IconButtonLink } from "@stubhub/broadway-web";
import { useFormattedContent } from "src/shared/components/content";
import { PE_KEYS } from "src/shared/constants/PageEventKeys";
import { PE_TYPE } from "src/shared/constants/PageEventTypes";
import { useStorePageEvent } from "src/shared/hooks/useStorePageEvent";
import { iconButtonLinkColor } from "./styles";

const iconButtonLinkClasses = {
  root: iconButtonLinkColor,
};

interface Props {
  url: string;
  platform: string;
  categoryName: string;
  platformIcon: ComponentProps<typeof IconButtonLink>["icon"];
}

export const SocialMediaLink: FC<Props> = memo(({ url, platform, categoryName, platformIcon }) => {
  const storePageEvent = useStorePageEvent();
  const altText = useFormattedContent("cid$#3339747#", [platform, categoryName]);
  return (
    <IconButtonLink
      classes={iconButtonLinkClasses}
      key={platform}
      href={url}
      target="_blank"
      rel="noreferrer"
      kind={ButtonKind.Neutral}
      shape={ButtonShape.Round}
      size={ButtonSize.Small}
      icon={platformIcon}
      aria-label={altText}
      onClick={() => {
        storePageEvent(PE_TYPE.CLICK, PE_KEYS.SOCIAL_MEDIA_LINK, `${categoryName} - ${platform}`);
      }}
    />
  );
});
SocialMediaLink.displayName = "SocialMediaLink";
